import { __assign } from "tslib";
import React from 'react';
import InternalFormField from './internal';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function FormField(props) {
    useTelemetry('FormField');
    return React.createElement(InternalFormField, __assign({}, props, { hideLabel: false }));
}
//# sourceMappingURL=index.js.map